"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSafariDetected = exports.default = exports.VIDEO_LOGGING_VERBOSE = void 0;
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _utils = require("../../../utils");
var _ = require("../..");
var _components = require("../../../components");
var _OTVideo = _interopRequireDefault(require("./OTVideo"));
var _VideoControls = _interopRequireDefault(require("./VideoControls"));
var _TopPanel = _interopRequireDefault(require("./TopPanel"));
var _getVideoCallErrorMessage = require("./getVideoCallErrorMessage");
require("./Video.less");
var _honeybadger = _interopRequireDefault(require("@honeybadger-io/js/dist/browser/honeybadger"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var isSafariDetected = (0, _utils.isSafari)();
exports.isSafariDetected = isSafariDetected;
var VIDEO_LOGGING_VERBOSE = process.env.REACT_APP_ENVIRONMENT !== 'production';
exports.VIDEO_LOGGING_VERBOSE = VIDEO_LOGGING_VERBOSE;
var useDevices = function useDevices(isVideoVisible) {
  var _window = window,
    opentok = _window.OT;
  var _useState = (0, _react.useState)({
      audio: [],
      video: []
    }),
    _useState2 = _slicedToArray(_useState, 2),
    allDevices = _useState2[0],
    setAllDevices = _useState2[1];
  var _useState3 = (0, _react.useState)({
      audio: undefined,
      video: undefined
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    devices = _useState4[0],
    setDevices = _useState4[1];
  (0, _react.useEffect)(function () {
    if (opentok && isVideoVisible) {
      opentok.getDevices(function (error, devices) {
        if (error) {
          console.error(error);
        } else {
          var audioDevices = devices.filter(function (_ref) {
            var kind = _ref.kind;
            return kind === 'audioInput';
          }) || [];
          var videoDevices = devices.filter(function (_ref2) {
            var kind = _ref2.kind;
            return kind === 'videoInput';
          }) || [];
          var audio = audioDevices[0];
          var video = videoDevices[0];
          setAllDevices({
            audio: audioDevices,
            video: videoDevices
          });
          setDevices({
            audio: audio,
            video: video
          });
          if (!video) {
            _utils.toast.warn(_objectSpread(_objectSpread({}, _getVideoCallErrorMessage.customErrMsgs.find(function (err) {
              return err.code === 'CUSTOM_OT_CAMERA_NOT_AVAILABLE';
            })), {}, {
              duration: Infinity
            }));
          }
        }
      });
    }
  }, [opentok, isVideoVisible]);
  return {
    allDevices: allDevices,
    devices: devices,
    setDevices: setDevices
  };
};
var useScreenShare = function useScreenShare() {
  // the differnece between `isScreenShareOn` and `screenSharingInProgress`
  // is `isScreenShareOn` is set to true when user pressed control to share the screen,
  // and `screenSharingInProgress` is set when sharing is already in process.
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    isScreenShareOn = _useState6[0],
    setIsScreenShareOn = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    screenSharingInProgress = _useState8[0],
    setScreenSharingInProgress = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    isSubscriberScreenSharingEnabled = _useState10[0],
    setIsSubscriberScreenSharingEnabled = _useState10[1];
  var toggleIsScreenShareOn = function toggleIsScreenShareOn() {
    setIsScreenShareOn(function (isOn) {
      return !isOn;
    });
  };
  var toggleScreenSharingEnabled = function toggleScreenSharingEnabled() {
    setScreenSharingInProgress(function (enabled) {
      return !enabled;
    });
  };
  (0, _react.useEffect)(function () {
    if (!screenSharingInProgress) {
      setIsScreenShareOn(false);
    }
  }, [screenSharingInProgress]);
  (0, _react.useEffect)(function () {
    if (!isScreenShareOn) {
      setScreenSharingInProgress(false);
    }
  }, [isScreenShareOn]);
  return {
    isScreenShareOn: isScreenShareOn,
    screenSharingInProgress: screenSharingInProgress,
    toggleIsScreenShareOn: toggleIsScreenShareOn,
    toggleScreenSharingEnabled: toggleScreenSharingEnabled,
    isSubscriberScreenSharingEnabled: isSubscriberScreenSharingEnabled,
    setIsSubscriberScreenSharingEnabled: setIsSubscriberScreenSharingEnabled
  };
};
var Video = function Video(_ref3) {
  var _user$profile;
  var allowFullScreen = _ref3.allowFullScreen,
    isVideoVisible = _ref3.isVideoVisible,
    _ref3$setIsVideoVisib = _ref3.setIsVideoVisible,
    setIsVideoVisible = _ref3$setIsVideoVisib === void 0 ? _lodash.noop : _ref3$setIsVideoVisib;
  var _useVideoChat = (0, _.useVideoChat)(),
    controlsVisible = _useVideoChat.controlsVisible,
    isFullScreen = _useVideoChat.isFullScreen,
    isMaximized = _useVideoChat.isMaximized,
    isSubscribed = _useVideoChat.isSubscribed,
    _onConnect = _useVideoChat.onConnect,
    onDisconnect = _useVideoChat.onDisconnect,
    onFinish = _useVideoChat.onFinish,
    setIsSubscribed = _useVideoChat.setIsSubscribed,
    toggleControlsVisible = _useVideoChat.toggleControlsVisible,
    _useVideoChat$videoCa = _useVideoChat.videoCallProps,
    apiKey = _useVideoChat$videoCa.apiKey,
    roomId = _useVideoChat$videoCa.roomId,
    token = _useVideoChat$videoCa.token,
    eventHandler = _useVideoChat.videoControlEventHandler;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isSubscriberVideoEnabled = _useState12[0],
    setIsSubscriberVideoEnabled = _useState12[1];
  var _useState13 = (0, _react.useState)(true),
    _useState14 = _slicedToArray(_useState13, 2),
    videoEnabled = _useState14[0],
    setVideoEnabled = _useState14[1];
  var _useState15 = (0, _react.useState)(true),
    _useState16 = _slicedToArray(_useState15, 2),
    audioEnabled = _useState16[0],
    setAudioEnabled = _useState16[1];
  var _useState17 = (0, _react.useState)(),
    _useState18 = _slicedToArray(_useState17, 2),
    error = _useState18[0],
    setError = _useState18[1];
  var _useState19 = (0, _react.useState)(null),
    _useState20 = _slicedToArray(_useState19, 2),
    errorMessage = _useState20[0],
    setErrorMessage = _useState20[1];
  var _useState21 = (0, _react.useState)(_utils.SessionEvents.Connecting),
    _useState22 = _slicedToArray(_useState21, 2),
    connectionStatus = _useState22[0],
    setConnectionStatus = _useState22[1];
  var _useDevices = useDevices(isVideoVisible),
    allDevices = _useDevices.allDevices,
    devices = _useDevices.devices,
    setDevices = _useDevices.setDevices;
  var _useScreenShare = useScreenShare(),
    isScreenShareOn = _useScreenShare.isScreenShareOn,
    screenSharingInProgress = _useScreenShare.screenSharingInProgress,
    toggleIsScreenShareOn = _useScreenShare.toggleIsScreenShareOn,
    toggleScreenSharingEnabled = _useScreenShare.toggleScreenSharingEnabled,
    isSubscriberScreenSharingEnabled = _useScreenShare.isSubscriberScreenSharingEnabled,
    setIsSubscriberScreenSharingEnabled = _useScreenShare.setIsSubscriberScreenSharingEnabled;
  (0, _react.useEffect)(function () {
    var audio = devices.audio,
      video = devices.video;
    setVideoEnabled(!!video);
    setAudioEnabled(!!audio);
  }, [devices]);
  var videoControlsProps = {
    audioEnabled: audioEnabled,
    videoEnabled: videoEnabled,
    screenSharingInProgress: screenSharingInProgress,
    toggleIsScreenShareOn: toggleIsScreenShareOn,
    isMaximized: isMaximized,
    toggleAudio: function toggleAudio(e) {
      e.stopPropagation();
      setAudioEnabled(function (v) {
        return !v;
      });
    },
    toggleVideo: devices.video && function (e) {
      e.stopPropagation();
      if (devices.video) {
        setVideoEnabled(function (v) {
          return !v;
        });
        setDevices(devices);
      }
    },
    onFinish: onFinish,
    user: user,
    isSubscribed: isSubscribed,
    allDevices: allDevices,
    devices: devices,
    setDevices: setDevices,
    eventHandler: eventHandler,
    visible: controlsVisible
  };
  (0, _react.useEffect)(function () {
    var errorNotification = (0, _getVideoCallErrorMessage.getVideoCallErrorMessage)(error, devices);
    if (!errorNotification) {
      return;
    }
    var description = errorNotification.description,
      _errorNotification$du = errorNotification.duration,
      duration = _errorNotification$du === void 0 ? Infinity : _errorNotification$du,
      message = errorNotification.message;
    if (!error || errorMessage === message) {
      return;
    }
    setErrorMessage(message);
    _utils.toast.error({
      title: message,
      description: description,
      duration: duration
    });
    _honeybadger.default.notify(error, {
      message: 'OpenTok Video Error'
    });
    onDisconnect();
    try {
      (0, _.trackUserEvent)({
        eventName: 'Tokbox Video Error',
        eventValues: {
          message: message,
          error: error === null || error === void 0 ? void 0 : error.name
        }
      });
    } catch (err) {
      _honeybadger.default.notify(error, {
        message: 'Heap Analytics Error'
      });
    }
  }, [devices, error, onDisconnect, errorMessage]);
  var onClick = function onClick() {
    if (isFullScreen) {
      toggleControlsVisible();
    }
  };
  var otProps = {
    apiKey: apiKey,
    audioEnabled: audioEnabled,
    screenSharingInProgress: screenSharingInProgress,
    toggleScreenSharingEnabled: toggleScreenSharingEnabled,
    isScreenShareOn: isScreenShareOn,
    toggleIsScreenShareOn: toggleIsScreenShareOn,
    connectionStatus: connectionStatus,
    devices: devices,
    isFullScreen: isMaximized,
    isSubscriberVideoEnabled: isSubscriberVideoEnabled,
    onConnect: function onConnect(id) {
      _onConnect(id).then(function () {
        setIsVideoVisible(true);
      });
    },
    onConnectionStatusChange: (0, _react.useCallback)(function (type) {
      switch (type) {
        case _utils.SessionEvents.Connected:
          setConnectionStatus(type);
          break;
        case _utils.SessionEvents.Disconnected:
          setConnectionStatus(type);
          setIsSubscribed(false);
          break;
        default:
      }
    }, []),
    onError: function onError(err) {
      _honeybadger.default.notify(error, {
        message: 'OpenTok Video Error'
      });
      setError(err);
    },
    onDisconnect: onDisconnect,
    onSubscribe: function onSubscribe() {
      return setIsSubscribed(true);
    },
    roomId: roomId,
    setIsSubscriberVideoEnabled: setIsSubscriberVideoEnabled,
    token: token,
    videoEnabled: videoEnabled,
    user: user,
    onFinish: onFinish,
    isSubscriberScreenSharingEnabled: isSubscriberScreenSharingEnabled,
    setIsSubscriberScreenSharingEnabled: setIsSubscriberScreenSharingEnabled
  };
  var isClinicianUser = (0, _utils.isClinician)(user);
  var userAvatarImage = isClinicianUser ? user === null || user === void 0 ? void 0 : (_user$profile = user.profile) === null || _user$profile === void 0 ? void 0 : _user$profile.image : '';
  var userAvatarName = isClinicianUser ? (0, _utils.personName)(user === null || user === void 0 ? void 0 : user.profile) : user === null || user === void 0 ? void 0 : user.nickName;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('video', {
      subscribed: isSubscribed
    }),
    id: "videoChat",
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "center",
    align: "middle",
    className: "video-session-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "video-session-wrapper"
  }, apiKey && roomId && token ? /*#__PURE__*/_react.default.createElement(_OTVideo.default, otProps) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_components.Avatar, {
    size: 135,
    imageId: userAvatarImage,
    name: userAvatarName,
    className: "rounded-full overflow-auto",
    isCdnImage: isClinicianUser
  })))), /*#__PURE__*/_react.default.createElement(_TopPanel.default, {
    connectionStatus: connectionStatus,
    allowFullScreen: allowFullScreen,
    screenSharingInProgress: screenSharingInProgress
  }), /*#__PURE__*/_react.default.createElement(_VideoControls.default, videoControlsProps));
};
Video.propTypes = {
  isMaximized: _propTypes.default.bool,
  onConnect: _propTypes.default.func,
  onFinish: _propTypes.default.func,
  videoCallProps: _propTypes.default.shape({
    apiKey: _propTypes.default.string,
    roomId: _propTypes.default.string,
    token: _propTypes.default.string
  })
};
var _default = Video;
exports.default = _default;